import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Toast.css';

export interface ToastProps {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
  onClose: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({ id, message, type, duration = 3000, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(id);
    }, duration);

    return () => clearTimeout(timer);
  }, [id, duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'ri-check-line';
      case 'error':
        return 'ri-error-warning-line';
      case 'warning':
        return 'ri-alert-line';
      case 'info':
        return 'ri-information-line';
      default:
        return 'ri-information-line';
    }
  };

  return createPortal(
    <div className={`toast toast-${type}`}>
      <div className="toast-content">
        <i className={`toast-icon ${getIcon()}`}></i>
        <span className="toast-message">{message}</span>
        <button 
          className="toast-close"
          onClick={() => onClose(id)}
          aria-label="Закрыть уведомление"
        >
          <i className="ri-close-line"></i>
        </button>
      </div>
    </div>,
    document.body
  );
};

export default Toast;
